'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var DemandTransparencyPanelController = function DemandTransparencyPanelController($scope, $rootScope, $state, $log, $q, constants, systemConstants, demandTransparencyDataRetrieverService, transitionSearchCriteriaService, momentService, daysToDepartureCalculatorService, userPreferencesService, userSecureService, directForecastingConfigurationService) {
  // stores gridId and the value of the <dimension, metric> string that the data was loaded for
  // if the identifier changes we need to load the new data
  var gridDataStatus = {};
  var market = _.get($scope, 'contextData.searchCriteria.market', null);
  var isDirectForecastMarket = directForecastingConfigurationService.isDirectForecastEnabled({
    market: market
  });
  $scope.views = [{
    label: 'Forecast Profile',
    value: constants.VIEW.FORECAST_PROFILE
  }, {
    label: 'DTD Matrix',
    value: constants.VIEW.DTD_MATRIX,
    disabled: isDirectForecastMarket
  }, {
    label: 'All Data',
    value: constants.VIEW.ALL_DATA,
    disabled: isDirectForecastMarket
  }, {
    label: 'Forecast Data',
    value: constants.VIEW.FORECAST_DATA,
    disabled: isDirectForecastMarket
  }];
  $scope.selectedView = userPreferencesService.getUserSettingComponent('defaultForecastProfile') || constants.VIEW.FORECAST_PROFILE;
  $scope.selectedMetric = undefined;
  $scope.selectedDates = [];
  $scope.quickFilterData = {
    classGroup: undefined,
    seasons: undefined,
    dows: undefined,
    dtd: undefined
  };
  $scope.demandInitializationDisabled = !userSecureService.hasAuthorization('demand-initialization', 'write');
  $scope.seasonalityDisabled = !userSecureService.hasAuthorization('seasonality', 'read', true, 'write');
  $scope.dataReadyForGrid = function (gridView) {
    return $scope.demandTransparencyAttributes !== undefined && gridDataStatus[getGridId(gridView)] !== undefined;
  };
  function constructQuickFilterData(originalAttrs, initAttrs) {
    return {
      dtd: initAttrs.rtp,
      classGroup: initAttrs.classGroup,
      seasons: [initAttrs.season],
      dows: [initAttrs.dowGroup],
      originalAttrs: originalAttrs
    };
  }
  function getApplicableProfileLevel(profileData) {
    var highestProfileLevel = _.chain(profileData).map('profileLevel').map(function (d) {
      return constants.PROFILE_LEVELS[d];
    }).max().value();
    return constants.INVERTED_PROFILE_LEVELS[highestProfileLevel];
  }
  function showErrorAndGoBack(message) {
    $log.error('DemandTransparencyPanelController: showErrorAndGoBack - ' + message);
    toastr.error(message);
    $scope.backToOriginalScreen();
  }
  function showWarningAndGoBack(message) {
    $log.warn('DemandTransparencyPanelController: showWarnAndGoBack - ' + message);
    toastr.warning(message);
    $scope.backToOriginalScreen();
  }
  function validInitAttributes(attrs) {
    return attrs && attrs.market && attrs.classGroup && attrs.lastProcessedDateMoment && attrs.spos && attrs.season && attrs.dowGroup && attrs.departureDate && (attrs.mappedProfileLevel || attrs.regularProfileLevel);
  }
  function getValidationErrorMessage(attrs) {
    if (attrs) {
      if (!attrs.season) {
        return ' - missing Season';
      }
      if (!attrs.market) {
        return ' - missing Market';
      }
      if (!attrs.classGroup) {
        return ' - missing Class Group';
      }
      if (!attrs.lastProcessedDateMoment) {
        return ' - missing Last Processed Date ';
      }
      if (!attrs.spos) {
        return ' - missing Significant Point of Sale';
      }
      if (!attrs.dowGroup) {
        return ' - missing Day of Week Group';
      }
      if (!(attrs.mappedProfileLevel || attrs.regularProfileLevel)) {
        return ' - missing Profile Level';
      }
    }
    return '';
  }
  function readForecastProfileData(initAttrs, successAction) {
    if (!validInitAttributes(initAttrs)) {
      var errorMessage = 'Invalid attributes for Demand Transparency navigation' + getValidationErrorMessage(initAttrs);
      $log.error(errorMessage + '\ninitAttrs: ' + JSON.stringify(initAttrs));
      showErrorAndGoBack(errorMessage);
      return $q.reject(errorMessage);
    }
    var origin = initAttrs.market.split('-')[0];
    return demandTransparencyDataRetrieverService.getForecastProfileData(initAttrs, constructQuickFilterData($scope.quickFilterData.originalAttrs, initAttrs), $scope.dataDimension).then(function (profileData) {
      return demandTransparencyDataRetrieverService.getAirportTimezoneOffset(origin).then(function (airportTimeZoneData) {
        var lastProcessedUTC = momentService.copy(initAttrs.lastProcessedDateMoment, momentService.TYPE.LOCAL_DATE_TIME);
        initAttrs.airportTimeZoneData = airportTimeZoneData;
        initAttrs.lastProcessedMoment = initAttrs.lastProcessedDateMoment;
        initAttrs.rtp = daysToDepartureCalculatorService.calculate(lastProcessedUTC, airportTimeZoneData, initAttrs.departureDate);
        initAttrs.profileLevel = getApplicableProfileLevel(profileData || []);
        initAttrs.targetProfileLevel = 'MQ_SPOS_S_DOWG';
        $scope.quickFilterData = constructQuickFilterData($scope.quickFilterData.originalAttrs, initAttrs);
        $log.debug('initAttrs: ' + JSON.stringify(initAttrs));
        $log.debug('quickFilterData: ' + JSON.stringify($scope.quickFilterData));
        successAction();
      }, function () {
        showWarningAndGoBack('Airport Timezone Offset does not exist for selected market!');
      });
    }, function () {
      showWarningAndGoBack('Demand profile does not exist for selected market!');
    });
  }
  function adjustGridDataRetrievers() {
    var attrs = $scope.demandTransparencyAttributes;
    if (attrs !== undefined && attrs.market !== undefined) {
      var market = attrs.market.split('-');
      var classGroup = $scope.quickFilterData.classGroup;
      demandTransparencyDataRetrieverService.getDtdGridDataRetriever($scope.dataDimension, $scope.selectedMetric, attrs.carrier, attrs.market, attrs.spos, classGroup, $scope.selectedDates);
      demandTransparencyDataRetrieverService.getAllDataGridRetriever($scope.dataDimension, $scope.selectedMetric, attrs.carrier, attrs.market, attrs.spos, classGroup, $scope.selectedDates);
      demandTransparencyDataRetrieverService.getForecastDataGridDataRetriever($scope.dataDimension, attrs.carrier, market[0], market[1], attrs.spos, classGroup);
    }
  }

  // returns the state of the screen in a form of a string, if the string changes we should update a visible grid
  function getScreenState() {
    var filterData = $scope.quickFilterData;
    return $scope.dataDimension + '-' + $scope.selectedMetric + '-' + filterData.classGroup + '-' + filterData.seasons + '-' + filterData.dows + '-' + filterData.dtd + '-' + $scope.selectedDates.join('-');
  }
  function getGridId(viewId) {
    return 'demand-transparency-' + viewId;
  }

  // we have to force the chart to redraw, because quickfilter might have changed when the chart was not active
  function updateVisibleChart() {
    if ($scope.selectedView === 'forecast-profile') {
      $scope.$broadcast('forecast-profile-chart:redraw');
    }
  }

  // we want to update the grid only if a metric or data dimension was changed
  function updateVisibleGrid() {
    var gridId = getGridId($scope.selectedView);
    var screenState = getScreenState();
    adjustGridDataRetrievers();
    if (gridDataStatus[gridId] !== screenState && $scope.quickFilterData.classGroup) {
      $scope.$broadcast('grid:loadData:' + gridId);
      gridDataStatus[gridId] = screenState;
    }
  }
  function stateChangeSuccessHandler(searchCriteria) {
    return readForecastProfileData(searchCriteria, function () {
      $scope.demandTransparencyAttributes = searchCriteria;
    });
  }
  $scope.backToOriginalScreen = function () {
    $rootScope.$broadcast('demand-transparency:swap', false);
  };

  // new Market, POS, Product Group selected in Market Analysis screen
  $scope.$watch('contextData', function () {
    if ($scope.contextData) {
      $scope.originalSearchCriteria = $scope.contextData.searchCriteria;

      // store the original attributes to determine if we should request an original profile (using 'api/configuration/hep/key')
      // or grab all profiles (with 'api/configuration/hep/marketinitdemandprofile')
      $scope.quickFilterData.originalAttrs = _.pick($scope.contextData.searchCriteria, ['season', 'dowGroup', 'classGroup']);
      stateChangeSuccessHandler($scope.contextData.searchCriteria).then(function () {
        $scope.quickFilterData.originalAttrs.dtd = $scope.quickFilterData.dtd;
        updateVisibleGrid();
      });
    }
  });
  $scope.$watch('dataDimension', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      if ($scope.demandTransparencyAttributes) {
        readForecastProfileData($scope.demandTransparencyAttributes, function () {
          updateVisibleGrid();
        });
      } else if ($scope.originalSearchCriteria) {
        stateChangeSuccessHandler($scope.originalSearchCriteria);
      }
    }
  });
  function quickFilterChanged(data) {
    _.assign($scope.quickFilterData, data);
    $log.debug('applying new quickFilterData: ' + JSON.stringify($scope.quickFilterData));
  }

  // quick filter changed (first reload the data based on the class, than apply quick filter)
  $scope.$on('demand-transparency:quick-filter-changed', function (event, data) {
    if ($scope.quickFilterData.classGroup !== data.classGroup) {
      $scope.demandTransparencyAttributes.classGroup = data.classGroup;
      readForecastProfileData($scope.demandTransparencyAttributes, _.wrap(data, quickFilterChanged));
    } else {
      quickFilterChanged(data);
    }
  });

  // selected metric changed in the chart
  $scope.$watch('selectedMetric', function () {
    if ($scope.selectedMetric !== undefined) {
      updateVisibleGrid();
    }
  });

  // a different tab was selected
  $scope.$watch('selectedView', function () {
    if ($scope.selectedView !== undefined) {
      updateVisibleGrid();
      updateVisibleChart();
    }
  });
  $scope.$on('demand-transparency:grid-dates-changed', function (event, dates) {
    if (dates !== undefined) {
      _.remove(dates, _.isEmpty);
      $scope.selectedDates = dates;
      updateVisibleGrid();
    }
  });
  $scope.demandReinitialization = function () {
    var rowParams = $scope.demandTransparencyAttributes.market.split('-');
    $state.go('app.system-status', {
      transitionData: {
        skipSearch: true,
        'system-status:force-tab': {
          tabId: systemConstants.SCREEN_VALUE.SYSTEM_STATUS.REINITIALIZATION
        },
        'demand-reinitialization:force-add-row': {
          origin: rowParams[0],
          destination: rowParams[1]
        }
      }
    });
  };
  $scope.demandSeasonality = function () {
    var searchCriteria = transitionSearchCriteriaService.demandTransparencyToSeasonality([$scope.demandTransparencyAttributes.market]);
    $state.go('app.seasonality', {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: searchCriteria
      }
    });
  };
};
DemandTransparencyPanelController.$inject = ['$scope', '$rootScope', '$state', '$log', '$q', 'DemandTransparencyConstants', 'SystemConstants', 'DemandTransparencyDataRetrieverService', 'TransitionSearchCriteriaService', 'MomentService', 'DaysToDepartureCalculatorService', 'UserPreferencesService', 'UserSecureService', 'DirectForecastingConfigurationService'];
module.exports = DemandTransparencyPanelController;